export const colors = {
    blue: "#2196f3",
    homeBlue: "#0C47A5",
    darkBlue: "#1a1a2e",
    lightRed1: "#f8d7da",
    lightRed2: "#f5c6cb",
    red: "#ff4d4f",
    darkRed: "#721c24",
    lightBlueGrey: "#b0b0c3",
    lightGreen: "#D4F1E3",
    boldGreen: "#1A6A46",
    lightGreenSecondary: "#D0FEF6",
    boldGreenSecondary: "#02A067",
    boldOrange: "#BA8806",
    lightOrange: "#FFFCF0",
};

export const MAX_WIDTH = "600px";